import { TipsMapType } from '@op/components/BubbleCommon';

export const MemosPopMusicTrends: TipsMapType = {
  zh: '以大众传唱度高的歌曲为核心，通过旋律、歌词或歌手话题引发二次创作与传播的现象。',
  en: 'Viral trends driven by widely popular songs, where melodies, lyrics, or artist-related topics inspire remixes and user-generated content.',
};

export const MemosAudioMemes: TipsMapType = {
  zh: '通过特定声音片段（台词、音效）形成文化符号，具有强重复性和魔性传播力。',
  en: 'Memes built around specific sound clips, voice lines, or effects that become cultural symbols through frequent and repetitive reuse.',
};

export const MemosEmotionalTrends: TipsMapType = {
  zh: '以共情、解压、讽刺等情绪驱动传播的内容，反映社会集体心理。',
  en: 'Trends driven by shared emotions such as empathy, stress relief, irony, or satire, reflecting collective social sentiment.',
};

export const MemosLifestyleCulturalTrends: TipsMapType = {
  zh: '指特定时期内被社会或特定群体广泛模仿的生活方式、审美风格或行为模式，反映时代精神与集体意识。',
  en: 'Trends where lifestyles, aesthetics, or behaviors are widely imitated within a specific period, reflecting cultural identity and the spirit of the times.',
};

export const MemosGamingViralMoments: TipsMapType = {
  zh: '病毒式传播的游戏片段（搞笑 BUG、逆天操作、速通）、玩家社区流行梗，具有娱乐性并快速出圈。',
  en: 'Viral gameplay moments such as funny bugs, impressive skills, speedruns, or community memes that rapidly spread beyond core gaming audiences.',
};

export const MemosAbsurdRemixMemeCulture: TipsMapType = {
  zh: '通过解构、重复、荒诞手法重构原始内容，形成亚文化符号体系。',
  en: 'A subcultural meme style characterized by deconstruction, repetition, and surreal remixing of original content.',
};

export const MemosSeasonalHolidayTrends: TipsMapType = {
  zh: '结合传统或新兴节日的文化符号或商业节点，触发情感共鸣或消费行为。',
  en: 'Trends tied to traditional or emerging holidays, leveraging cultural symbols or commercial moments to spark emotional engagement or consumer behavior.',
};

export const MemosEntertainmentMediaTrends: TipsMapType = {
  zh: '围绕影视、综艺、游戏等泛娱乐内容产生的衍生话题、讨论或二次创作。',
  en: 'Trends derived from movies, TV shows, variety programs, and games, including discussions, spin-offs, and fan-created content.',
};

// hot_content_type 分类
export const MemosActionGesture: TipsMapType = {
  zh: '以夸张、可模仿的肢体动作或姿势为核心记忆点，具有高度可复刻性，易被模仿与二次创作。',
  en: 'Memes driven by distinctive, repeatable physical actions or gestures that are easy to imitate and remix.',
};

export const MemosVisualIdentity: TipsMapType = {
  zh: '通过独特的人物形象、表情、妆容、服装或视觉符号形成强烈识别度。',
  en: 'Memes centered on unique visual identity such as appearance, facial expressions, outfits, or recognizable visual traits.',
};

export const MemosAudioSignature: TipsMapType = {
  zh: '依赖洗脑旋律、魔性台词或重复音效传播，音频本身即为核心梗点。',
  en: 'Memes powered by recognizable music, dialogue clips, or sound effects with strong repetition value.',
};

export const MemosTextExpression: TipsMapType = {
  zh: '通过固定句式、字幕结构、文字搭配表情符号形成传播模板。',
  en: 'Memes built around repeatable text formats, catchphrases, subtitles, or emoji-based expressions.',
};

export const MemosAbstractHybrid: TipsMapType = {
  zh: '无法单一归类，通常由多种元素（动作、音频、视觉、文本）叠加，偏抽象或亚文化向。',
  en: 'Memes that combine multiple elements (audio, visuals, actions, text), often surreal or subculture-driven.',
};

// hot_topic_type 映射
export const HotTopicTypeMap: Record<string, TipsMapType> = {
  'pop music trends': MemosPopMusicTrends,
  'audio memes': MemosAudioMemes,
  'emotional trends': MemosEmotionalTrends,
  'lifestyle & cultural trends': MemosLifestyleCulturalTrends,
  'gaming viral moments': MemosGamingViralMoments,
  'absurd & remix meme culture': MemosAbsurdRemixMemeCulture,
  'seasonal & holiday trends': MemosSeasonalHolidayTrends,
  'entertainment & media trends': MemosEntertainmentMediaTrends,
};

// hot_content_type 映射
export const HotContentTypeMap: Record<string, TipsMapType> = {
  'signature actions & gestures': MemosActionGesture,
  'iconic visual appearance': MemosVisualIdentity,
  'signature audio & sound': MemosAudioSignature,
  'catchphrase & text memes': MemosTextExpression,
  'abstract / hybrid memes': MemosAbstractHybrid,
};

// 通过 key 获取提示词
export function getMemosByKey(
  key: string,
  type: 'topic' | 'content' = 'topic',
): TipsMapType | undefined {
  const map = type === 'topic' ? HotTopicTypeMap : HotContentTypeMap;
  return map[key.toLowerCase()];
}

export const MemosHeaderTips: TipsMapType = {
  en: 'Optimizing trending memes and related videos. Minor mismatches may occur.',
  zh: '热梗热度及相关视频调优中，可能存在少量非精准匹配视频。',
};
